

/* Swiper is loaded with defer — safe to init on window.load */
window.addEventListener("load", function () {

  const init = (SECTION_ID) => {
    if (typeof Swiper === "undefined") return; // should not happen after window.load

    var swiper = new Swiper("#by-hs-swiper-" + SECTION_ID, {
      loop: true,
      speed: 450,
      allowTouchMove: true,
      effect: "fade",
      fadeEffect: { crossFade: true },
      pagination: {
        el: "#by-hs-swiper-" + SECTION_ID + " .by-hs__pagination",
        clickable: true,
      },
    });

    /* ── Hotspot hover → change slide ────────────────────── */
    var section = document.getElementById("by-hotspot-image-" + SECTION_ID);
    if (!section) return;

    var hotspots = Array.from(section.querySelectorAll(".by-hs__hotspot"));

    hotspots.forEach(function (btn) {
      btn.addEventListener(
        "mouseenter",
        function () {
          var idx = parseInt(this.getAttribute("data-slide-index"), 10);
          if (!isNaN(idx)) {
            swiper.slideTo(idx);
            hotspots.forEach(function (h) {
              h.classList.remove("is-active");
            });
            this.classList.add("is-active");
          }
        }.bind(btn),
      );

      // btn.addEventListener('mouseleave', function () {
      //   this.classList.remove('is-active');
      // });
    });

    /* Keep active class in sync when slide changes via pagination */
    swiper.on("slideChange", function () {
      hotspots.forEach(function (h) {
        h.classList.remove("is-active");
      });
      var matching = section.querySelector(
        '.by-hs__hotspot[data-slide-index="' + swiper.activeIndex + '"]',
      );
      if (matching) matching.classList.add("is-active");
    });
  };

  const sections = document.querySelectorAll(".by-hotspot-image");
  sections.forEach((section) => {
    const sectionId = section.dataset.sectionId;
    init(sectionId);
  });
});
